import { getCountryCode } from '../utils';
// Firebase project configurations
const firebaseConfigs = {
    'us': {
        apiKey: 'AIzaSyAGYoU0G2zLu2aGkWDGgAaoZPLtfaU45sY',
        authDomain: 'flype-a8461.firebaseapp.com',
        databaseURL: 'https://flype-a8461.firebaseio.com',
        projectId: 'flype-a8461',
        storageBucket: 'flype-a8461.appspot.com',
        messagingSenderId: '307499181580',
        appId: '1:307499181580:web:97f6688d48e8507b043029',
        measurementId: 'G-K54LJFDZSX',
    },
    'uae': {
        apiKey: "AIzaSyD44wxyM-4iWhwT27YEPO6ESUpFqeTqFeQ",
        authDomain: "flype-gulf.firebaseapp.com",
        databaseURL: "https://flype-gulf.firebaseio.com",
        projectId: "flype-gulf",
        storageBucket: "flype-gulf.firebasestorage.app",
        messagingSenderId: "892240643765",
        appId: "1:892240643765:web:4b818d02ce544f225960fc",
        measurementId: "G-KQ2HRR7314"
    }
};


// Export the current config
const currentConfig = firebaseConfigs[getCountryCode()];

export default currentConfig;
